import React from 'react';
import PropTypes from 'prop-types';
import MLDialog from '../../MLDialog/MLDialog';
import MLButton from '../../MLButton';
import s from './UnlinkReefDialog.module.css';

function UnlinkReefDialog(props) {
  const { onClose, onSubmit, show, isCourseLinked, disableEnforceFocus } =
    props;
  const whatToDisconnect = isCourseLinked ? 'course' : 'account';

  const actions = [
    <MLButton
      key="disconnect-btn"
      btnType="secondary"
      className={s.btnSecondaryRed}
      testId="unlink_reef_dialog_submit_btn"
      onClick={() => {
        onSubmit();
      }}
    >
      Yes, Disconnect
    </MLButton>,
    <MLButton
      key="stay-connected-btn"
      btnType="primary"
      testId="unlink_reef_dialog_cancel_btn"
      onClick={onClose}
    >
      No, Stay Connected
    </MLButton>,
  ];

  return (
    <MLDialog
      className={s.unlinkReefDialog}
      title="Unlink iClicker"
      actions={actions}
      show={show}
      onClose={onClose}
      testId="unlink_reef_dialog"
      closeTestId="unlink_reef_dialog_close"
      disableEnforceFocus={disableEnforceFocus}
    >
      <p
        className={s.dialogText}
      >{`Are you sure you want to disconnect from your iClicker ${whatToDisconnect}?`}</p>
      <p className={s.dialogText}>
        <strong className={s.noteLabel}>Note:</strong> Disconnecting your
        iClicker course will remove all iClicker columns from your Achieve
        Gradebook.
      </p>
    </MLDialog>
  );
}

UnlinkReefDialog.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  show: PropTypes.bool,
  isCourseLinked: PropTypes.bool,
  disableEnforceFocus: PropTypes.bool,
};

export default UnlinkReefDialog;
